module.exports = __webpack_public_path__ + "static/media/on-going.790af106.png";